import React from "react";
import Layout from "../Componants/Layout";
import { Col, Container, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

export default function HelpSupport() {
  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3 className="text-center">Help & Support</h3>
            <Row>
              <Col lg={8} className="mx-auto">
                <div className="my-profile-title">
                  <h4>FAQs</h4>
                </div>
                <div className="faq-list-accro">
                  <Accordion flush>
                    {/* FAQ 1 */}
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>What is SparkPro?</Accordion.Header>
                      <Accordion.Body>
                        SparkPro is the UK’s dedicated platform for hiring
                        certified electricians and connecting them with
                        customers seeking reliable electrical services. We help
                        electricians find quality leads and secure more work
                        with ease.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 2 */}
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        How do I sign up as an electrician?
                      </Accordion.Header>
                      <Accordion.Body>
                        Signing up is quick and easy! Simply visit our website,
                        complete the registration form, and start receiving
                        leads right away.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 3 */}
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        What are the subscription costs?
                      </Accordion.Header>
                      <Accordion.Body>
                        We offer flexible subscription plans to fit your needs:
                        <ul>
                          <li>£80/month for 10 quotes</li>
                          <li>£120/month for 20 quotes</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 4 */}
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        What are the one-off purchase costs?
                      </Accordion.Header>
                      <Accordion.Body>
                        If you prefer not to subscribe, you can purchase quotes
                        as needed:
                        <ul>
                          <li>10 quotes for £90</li>
                          <li>20 quotes for £130</li>
                          <li>50 quotes for £180</li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 5 */}
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        What happens after my 3-month free trial?
                      </Accordion.Header>
                      <Accordion.Body>
                        Once your 3-month free trial ends, you’ll be moved to
                        the £80/month plan for 10 quotes unless you choose a
                        different plan. You can start paying earlier to access
                        more quotes if needed.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 6 */}
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        Can I change my subscription plan?
                      </Accordion.Header>
                      <Accordion.Body>
                        Yes, you can upgrade or downgrade your subscription at
                        any time to match your needs.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 7 */}
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                        How many quotes do I get each month?
                      </Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>
                            During the free trial: 5 free quotes per month
                          </li>
                          <li>
                            After the trial: With the £80/month plan, you’ll get
                            10 quotes, and with the £120/month plan, you’ll get
                            20 quotes.
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 8 */}
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                        How does the electrician verification process work?
                      </Accordion.Header>
                      <Accordion.Body>
                        Electricians can get verified on SparkPro by having
                        their credentials checked, which increases their
                        visibility and helps them get recommended to customers.
                        Verified electricians are more likely to attract leads
                        and secure bookings.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 9 */}
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                        Do I have to pay upfront?
                      </Accordion.Header>
                      <Accordion.Body>
                        Subscriptions are billed monthly. One-off purchases are
                        paid at the time of purchase.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 10 */}
                    <Accordion.Item eventKey="9">
                      <Accordion.Header>
                        How are leads delivered?
                      </Accordion.Header>
                      <Accordion.Body>
                        Leads are sent directly to your email or through the
                        SparkPro platform, based on your preferences.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 11 */}
                    <Accordion.Item eventKey="10">
                      <Accordion.Header>
                        Can I cancel my subscription?
                      </Accordion.Header>
                      <Accordion.Body>
                        Yes, you can cancel your subscription at any time. There
                        are no long-term commitments.
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* FAQ 12 */}
                    <Accordion.Item eventKey="11">
                      <Accordion.Header>
                        How can I contact SparkPro for support?
                      </Accordion.Header>
                      <Accordion.Body>
                        Need help?
                        You can contact us at
                        <b> <a style={{ textDecoration: "none" }} href="mailto: contact@sparkpro.app"> contact@sparkpro.app</a> </b>
                        and we'll get back
                        to you as soon as possible.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>

                <div className="my-profile-title">
                  <h4>Contact Us</h4>
                  <p>
                    If you need assistance with your account or technical
                    issues, you can reach out to us on the details below.
                  </p>
                </div>
                <Row>

                  <Col lg={12} className="mt-lg-0 mt-3">
                    <div className="contact-us-box">
                      <div>
                        <h4>
                          Email Us
                          <br />
                          <a style={{ textDecoration: "none" }} href="mailto: contact@sparkpro.app"> contact@sparkpro.app</a>
                        </h4>
                        <p>
                          Response Time <br />
                          24 - 48 Hours
                        </p>
                      </div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="60"
                          height="60"
                          viewBox="0 0 60 60"
                          fill="none"
                        >
                          <path
                            d="M8.5 20C8.5 17.6147 8.50212 15.9263 8.67414 14.6469C8.84229 13.3962 9.15611 12.687 9.67157 12.1716C10.187 11.6561 10.8962 11.3423 12.1469 11.1741C13.4263 11.0021 15.1147 11 17.5 11H42.5C44.8853 11 46.5737 11.0021 47.8531 11.1741C49.1038 11.3423 49.813 11.6561 50.3284 12.1716C50.8439 12.687 51.1577 13.3962 51.3259 14.6469C51.4979 15.9263 51.5 17.6147 51.5 20V41.5H8.5V20Z"
                            fill="#D9D9D9"
                            fillOpacity="0.5"
                            stroke="black"
                            strokeWidth="2"
                          />
                          <path
                            d="M9.16667 41.5C7.69391 41.5 6.5 42.6939 6.5 44.1667C6.5 46.5599 8.4401 48.5 10.8333 48.5H49.1667C51.5599 48.5 53.5 46.5599 53.5 44.1667C53.5 42.6939 52.3061 41.5 50.8333 41.5H9.16667Z"
                            stroke="black"
                            strokeWidth="2"
                          />
                        </svg>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </Layout>
    </>
  );
}
